
import { useEffect, useState } from "react";
import { useToast } from "@/hooks/use-toast";

interface ScrollTriggeredPopupProps {
  scrollThreshold?: number;
  delay?: number;
}

const ScrollTriggeredPopup = ({
  scrollThreshold = 40, // Default to 40% of page height
  delay = 2000, // Default to 2 seconds
}: ScrollTriggeredPopupProps) => {
  const [hasTriggered, setHasTriggered] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    // Check if we've already shown the popup in this session
    const hasShownPopup = sessionStorage.getItem("kitPopupShown");
    if (hasShownPopup === "true") {
      return;
    }

    let scrollTimeout: NodeJS.Timeout | null = null;

    const handleScroll = () => {
      if (hasTriggered || scrollTimeout) return;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      
      // Calculate scroll percentage
      const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;

      if (scrollPercentage >= scrollThreshold) {
        // Set timeout to avoid triggering immediately when threshold is reached
        scrollTimeout = setTimeout(() => {
          try {
            if (window.Kit && typeof window.Kit.openModal === 'function') {
              window.Kit.openModal('6344c821ba');
              setHasTriggered(true);
              sessionStorage.setItem("kitPopupShown", "true");
              console.log("Kit popup triggered successfully");
            } else {
              console.warn("Kit is not available or doesn't have openModal method");
            }
          } catch (error) {
            console.error("Failed to open Kit modal:", error);
            toast({
              title: "Error",
              description: "Could not open the subscription form. Please try again later.",
              variant: "destructive",
            });
          }
        }, delay);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [hasTriggered, scrollThreshold, delay, toast]);

  return null; // This component doesn't render anything
};

export default ScrollTriggeredPopup;
